import { getBasicSearchParam } from '@/utils/search';
const getDefaultSearchParam = () => {
    return {
        param: getBasicSearchParam()
    }
}

const state = getDefaultSearchParam()

const mutations = {
    SET_SEARCHPARAM: (state, newParam) => {
        state.param = newParam
    }
}

const actions = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

